import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

// Ambil daftar sumber bantuan untuk dropdown (search + paginate)
// type: 'questionnaire' | 'verifikasi' | 'registerUsulan'
export const getSourceList = (type, params = {}) => {
  const page = params.page || 1;
  const limit = params.limit || 20;
  const search = params.search || '';
  const kecamatan = params.kecamatan || '';
  const desaKelurahan = params.desaKelurahan || '';

  if (type === 'questionnaire') {
    return axios.get(`${BASE}/getquestionnaires`, {
      params: {
        page,
        limit,
        searchName: search,
        ...(kecamatan ? { kecamatan } : {}),
        ...(desaKelurahan ? { desaKelurahan } : {}),
      },
    })
      .then((res) => ({
        rows: (res.data.data || []).map((q) => ({
          // Informasi Dasar
          id: q.id,
          sourceType: 'questionnaire',
          label: `${q.id} - ${q.namaLengkapKK || '-'} | NIK:${q.nomorKTP || '-'} (${q.kecamatan || '-'}, ${q.desaKelurahan || '-'})`,
          
          // Data Pribadi
          namaLengkapKK: q.namaLengkapKK,
          nama: q.namaLengkapKK,
          nomorKK: q.nomorKK,
          nomorKTP: q.nomorKTP,
          nik: q.nomorKTP,
          usia: q.usia,
          tanggallahir: q.tanggallahir,
          jenisKelamin: q.jenisKelamin,
          
          // Alamat
          alamatRumah: q.alamatRumah,
          alamat: q.alamatRumah,
          kecamatan: q.kecamatan,
          desaKelurahan: q.desaKelurahan,
          
          // Status & Kategori
          kategori: q.kategori,
          score: q.score,
          statusrumah: q.statusrumah,
          verifikasiBantuan: q.verifikasiBantuan,
          
          // Data Tambahan Questionnaire
          nomorUrut: q.nomorUrut,
          nomorRumahPadaPeta: q.nomorRumahPadaPeta,
          asalKTP: q.asalKTP,
          jumlahKK: q.jumlahKK,
          jumlahPenghuni: q.jumlahPenghuni,
          pendidikanTerakhir: q.pendidikanTerakhir,
          pekerjaan: q.pekerjaan,
          fungsiBangunan: q.fungsiBangunan,
          penghasilan: q.penghasilan,
          statusKepemilikanRumah: q.statusKepemilikanRumah,
          asetRumahDiTempatLain: q.asetRumahDiTempatLain,
          statusKepemilikanTanah: q.statusKepemilikanTanah,
          asetTanahDiTempatLain: q.asetTanahDiTempatLain,
          sumberPenerangan: q.sumberPenerangan,
          dayaListrik: q.dayaListrik,
          bantuanPerumahan: q.bantuanPerumahan,
          modelRumah: q.modelRumah,
          
          // Kondisi Rumah
          pondasi: q.pondasi,
          kolom: q.kolom,
          rangkaAtap: q.rangkaAtap,
          plafon: q.plafon,
          balok: q.balok,
          sloof: q.sloof,
          pintuJendelaKonsen: q.pintuJendelaKonsen,
          ventilasi: q.ventilasi,
          materialLantaiTerluas: q.materialLantaiTerluas,
          kondisiLantai: q.kondisiLantai,
          materialDindingTerluas: q.materialDindingTerluas,
          kondisiDinding: q.kondisiDinding,
          materialPenutupAtapTerluas: q.materialPenutupAtapTerluas,
          kondisiPenutupAtap: q.kondisiPenutupAtap,
          luasRumah: q.luasRumah,
          luasTanah: q.luasTanah,
          
          // Sanitasi & Air
          buanganAirLimbahRumahTangga: q.buanganAirLimbahRumahTangga,
          saranaPengelolaanLimbahCair: q.saranaPengelolaanLimbahCair,
          pemiliharaanSaranaPengelolaanLimbah: q.pemiliharaanSaranaPengelolaanLimbah,
          jenisTempatPembuanganAirTinja: q.jenisTempatPembuanganAirTinja,
          kepemilikanKamarMandiDanJamban: q.kepemilikanKamarMandiDanJamban,
          jumlahJamban: q.jumlahJamban,
          jenisKloset: q.jenisKloset,
          jenisTangkiSeptik: q.jenisTangkiSeptik,
          materialTangkiSeptik: q.materialTangkiSeptik,
          alasTangkiSeptik: q.alasTangkiSeptik,
          lubangPenyedotan: q.lubangPenyedotan,
          posisiTangkiSeptik: q.posisiTangkiSeptik,
          jarakTangkiSeptikDenganSumberAir: q.jarakTangkiSeptikDenganSumberAir,
          sumberAirMinum: q.sumberAirMinum,
          
          // Koordinat
          titikKoordinatRumah: q.titikKoordinatRumah,
          manualTitikKoordinatRumah: q.manualTitikKoordinatRumah,
          
          // Metadata
          tanggalPendataan: q.tanggalPendataan,
          catatan: q.catatan,
          adminId: q.adminId,
          // Foto rumah questionnaire (relasi hasMany Foto)
          fotos: (q.fotos || q.Fotos || []).map((f, i) => ({
            id: f.id,
            label: `Foto Rumah ${i + 1}`,
            foto_rumah: f.foto_rumah,
            questionnaireId: f.questionnaireId || q.id,
            type: 'rumah',
          })),
          
          // Source Info
          sourceId: q.id,
          sourceName: 'Questionnaire'
        })),
        totalPages: res.data.pagination?.totalPages ?? 1,
        currentPage: res.data.pagination?.currentPage ?? page,
      }));
  }

  if (type === 'verifikasi') {
    return axios.get(`${BASE}/getverifikasi`, {
      params: {
        page,
        limit,
        searchName: search,
        ...(kecamatan ? { searchKecamatan: kecamatan } : {}),
        ...(desaKelurahan ? { searchDesaKelurahan: desaKelurahan } : {}),
      },
    })
      .then((res) => ({
        rows: (res.data.data || []).map((v) => ({
          // Informasi Dasar
          id: v.id,
          sourceType: 'verifikasi',
          label: `${v.id} - ${v.namaKepalaKeluarga || '-'} | NIK:${v.nik || '-'} (${v.kecamatan || '-'}, ${v.desaKelurahan || '-'})`,
          
          // Data Pribadi
          namaKepalaKeluarga: v.namaKepalaKeluarga,
          nama: v.namaKepalaKeluarga,
          nomorKK: v.nomorKK,
          nik: v.nik,
          nomorKTP: v.nik,
          
          // Alamat
          alamat: v.alamat,
          kecamatan: v.kecamatan,
          desaKelurahan: v.desaKelurahan,
          
          // Status & Kategori
          statusVerifikasi: v.statusVerifikasi,
          kategori: v.kategori,
          verifikasiBantuan: v.verifikasiBantuan,
          score: v.score,
          
          // Data Tambahan Verifikasi
          fotoKK: v.fotoKK,
          rumahTinggalSendiri: v.rumahTinggalSendiri,
          statusKeluarga: v.statusKeluarga,
          usiaPernikahan: v.usiaPernikahan,
          StatusKepemilikanTanah: v.StatusKepemilikanTanah,
          fotoSuratKepemilikanTanah: v.fotoSuratKepemilikanTanah,
          apakahLokasiTanahSesuaiRTRW: v.apakahLokasiTanahSesuaiRTRW,
          tingkatPenghasilanKeluarga: v.tingkatPenghasilanKeluarga,
          jumlahPenghuniRumah: v.jumlahPenghuniRumah,
          foto: v.foto,
          
          // Koordinat
          titikKoordinatRumah: v.titikKoordinatRumah,
          manualTitikKoordinatRumah: v.manualTitikKoordinatRumah,
          
          // Foto & Dokumen (path dari backend, mis. images/verifikasi_xxx.jpg)
          fotoRumahSaatIni: v.fotoRumahSaatIni,
          fotoKK: v.fotoKK,
          fotoSuratKepemilikanTanah: v.fotoSuratKepemilikanTanah,
          foto: v.foto,
          // Array terpadu untuk preview di form tambah/monitoring
          fotos: [
            v.fotoRumahSaatIni ? { label: 'Foto Rumah Saat Ini', foto_rumah: v.fotoRumahSaatIni, type: 'rumah' } : null,
            v.foto ? { label: 'Foto Rumah', foto_rumah: v.foto, type: 'rumah' } : null,
            v.fotoKK ? { label: 'Foto KK', foto_rumah: v.fotoKK, type: 'dokumen' } : null,
            v.fotoSuratKepemilikanTanah ? { label: 'Surat Kepemilikan Tanah', foto_rumah: v.fotoSuratKepemilikanTanah, type: 'dokumen' } : null,
          ].filter(Boolean),
          
          // Metadata
          catatan: v.catatan,
          tanggalVerifikasi: v.tanggalVerifikasi,
          adminId: v.adminId,
          QuestionnaireId: v.QuestionnaireId,
          Admin: v.Admin || null,
          
          // Source Info
          sourceId: v.id,
          sourceName: 'Validasi'
        })),
        totalPages: res.data.pagination?.totalPages ?? 1,
        currentPage: res.data.pagination?.currentPage ?? page,
      }));
  }
  // registerUsulan
  return axios.get(`${BASE}/getregisterusulan`, {
    params: {
      page,
      limit,
      searchNameKK: search,
      ...(kecamatan ? { kecamatan } : {}),
      ...(desaKelurahan ? { desaKelurahan } : {}),
    },
  })
    .then((res) => {
      let rows = (res.data.registerUsulan || []).map((r) => ({
        id: r.id,
        label: `${r.id} - ${r.namaKepalaKeluarga || '-'} | NIK:${r.nik || '-'} (${r.kecamatan || '-'}, ${r.desaKelurahan || '-'})`,
        nama: r.namaKepalaKeluarga,
        alamat: r.alamatPemohon,
        kecamatan: r.kecamatan,
        desaKelurahan: r.desaKelurahan,
        status: r.status,
        nomorKK: r.nomorKK,
        nik: r.nik,
        nomorSurat: r.nomorSurat,
        perihal: r.perihal,
      }));
      // Client-side filter desa jika API belum support
      if (desaKelurahan) {
        rows = rows.filter((r) => String(r.desaKelurahan || '').toLowerCase() === String(desaKelurahan).toLowerCase());
      }
      return {
        rows,
        totalPages: res.data.totalPages ?? 1,
        currentPage: res.data.currentPage ?? page,
      };
    });
};

export default { getSourceList };
